
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["pinmap-demo-default","pinmap-demo-marker","pinmap-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__PinMap__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.en.md?type=demo')
};